angular.module('elfium').filter('elfiumDate', ['dateFilter', function (dateFilter) {
    return function (date) {
        return dateFilter(date, 'dd.MM.yyyy');
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumDateFilter.ts